import type {
  FormInputControl,
  FormSelectControl,
  FormSelectLocalControl,
  KycFinancialProfileType,
  KycFinancialProfileControlType,
} from 'src/types/form-config';

import { getFormDataLimit } from '../../../utils';

import { KycProps } from '../../../constants/kyc';

const totalIncome: FormSelectControl = {
  tag: 'select',
  placeholder: 'annual income',
  name: KycProps.ANNUAL_INCOME,
  type: 'text',
  label: 'Annual Income',
  options: [],
  validator: 'required=true',
  remoteOption: true,
  optionCategory: 'ANNUAL_INCOME',
  optionGetter: 'getOptions',
};

const investmentInterest: FormInputControl = {
  tag: 'input',
  placeholder: 'investment',
  name: KycProps.INVEST_INTEREST,
  type: 'text',
  label:
    'Are there any other funds/financial products you would like to invest in the future?',
  validator: 'required=true, string=true, min=2, max=50',
};

const investRegular: FormSelectLocalControl = {
  tag: 'select',
  placeholder: 'regular investment',
  name: KycProps.INVEST_REGULAR,
  type: 'text',
  label: 'Do you anticipate buying more shares on a regular basis?',
  options: [
    { value: false, display: 'No' },
    { value: true, display: 'Yes' },
  ],
  validator: 'required=true',
};

const controls: KycFinancialProfileControlType = [
  totalIncome,
  investmentInterest,
  investRegular,
];

const KycFinancialProfileData: KycFinancialProfileType = {
  name: 'financial_profile',
  display: 'Financial Profile',
  controls,
  getFormData: getFormDataLimit(controls),
};

export default KycFinancialProfileData;
